import { useQuery } from '@tanstack/react-query';
import { queryClient } from '../lib/queryClient';
import { useGetSdkStatusRequest } from '../api/useGetSdkStatusRequest';
export const useGetSdkStatus = (lineOfBusiness, clientId) => {
    const request = useGetSdkStatusRequest(lineOfBusiness, clientId);
    const { data, isError, isPending, isSuccess } = useQuery({
        queryKey: ['SdkStatus'],
        queryFn: () => request(),
    }, queryClient);
    return { isAvailable: data === null || data === void 0 ? void 0 : data.getSdkStatus.ok, isError, isSuccess, isPending };
};
